export const ANALYTICS_CHANNEL = 'media';

export const COMPONENT_NAME = 'linkPicker';

export const RECENT_SEARCH_LIST_SIZE = 5;

export const LINK_PICKER_WIDTH_IN_PX = 342;

export const LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK = '290px';
